import React, { useEffect, useState } from 'react';
import shortid from 'shortid';
import { has, is } from '../../services/classify';
import { Icon, IconSize } from '../icon';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Radio Component
 * @param checked {boolean} Checked Radio
 * @param className {string} Additionnal CSS Classes
 * @param disabled {boolean} Disabled
 * @param readOnly {boolean} readonly Radio
 * @param id {string} Id for button, by default id is generate
 * @param label {string|ReactNode} Label for Radio
 * @param onClick {ClickEvent}
 * @param onChange {ChangeEvent}
 * @param name {string} Name for radio
 * @param value {string} Value for radio
 * @param iconTile {IconName} Icon for Radio
 * @param narrow {boolean} Apply narrow
 * @param marginless {boolean} delete margin
 * @param children {React.ReactNode} If Children is provided, don't use label / Icon / Description
 */
const Radio = ({ checked, className, disabled, readonly, id = shortid.generate(), label, onChange, onClick, name, value, tile, description, iconTile, horizontalTile, children, labelClassName, spaced, inverted, testId, narrow, marginless, ...others }) => {
    const { styled } = useTrilogyContext();
    const [inputState, setInputState] = useState({ checked: checked || false });
    useEffect(() => {
        if (!readonly) {
            setInputState({ checked: checked || false });
        }
    }, [checked, readonly]);
    const classes = hashClass(styled, clsx('input', is('checkradio'), is('info'), is('hidden'), inverted && is('inverted'), className && !className.includes(is('inverted')) && has('background-color'), className));
    const labelClasses = hashClass(styled, clsx(checked && has('text-info'), spaced && is('spaced-between'), labelClassName));
    // Support legacy checkbox
    if (labelClassName || inverted || spaced) {
        return (React.createElement("div", { className: hashClass(styled, clsx('field')) },
            React.createElement("div", { className: hashClass(styled, clsx('control', disabled && is('disabled'))) },
                React.createElement("input", { "data-testid": testId, className: classes, type: 'radio', readOnly: readonly, id: id, disabled: disabled, name: name, value: value, checked: readonly ? checked : inputState.checked, onChange: (e) => {
                        return e;
                    }, onClick: (e) => {
                        const target = e.target;
                        if (!readonly && target.checked !== undefined) {
                            setInputState({ checked: target.checked });
                        }
                        target.value = value || '';
                        if (onChange) {
                            onChange({
                                radioId: target.id,
                                radioValue: target.value,
                                radioName: target.name,
                                radioChecked: target.checked,
                            });
                        }
                        if (onClick) {
                            onClick({
                                radioId: target.id,
                                radioValue: target.value,
                                radioName: target.name,
                                radioChecked: target.checked,
                            });
                        }
                    }, ...others }),
                React.createElement("label", { htmlFor: id, className: labelClasses }, label))));
    }
    return (React.createElement("div", { className: hashClass(styled, clsx(tile ? 'radio-tile' : 'radio', narrow && is('narrow'), marginless && is('marginless'), horizontalTile && is('horizontal'), className)) },
        React.createElement("input", { type: 'radio', readOnly: readonly, id: id, disabled: disabled, name: name, value: value, checked: readonly ? checked : inputState.checked, onChange: (e) => {
                return e;
            }, onClick: (e) => {
                const target = e.target;
                if (!readonly && target.checked) {
                    setInputState({ checked: target.checked });
                }
                target.value = value || '';
                if (onChange) {
                    onChange({
                        radioId: target.id,
                        radioValue: target.value,
                        radioName: target.name,
                        radioChecked: target.checked,
                    });
                }
                if (onClick) {
                    onClick({
                        radioId: target.id,
                        radioValue: target.value,
                        radioName: target.name,
                        radioChecked: target.checked,
                    });
                }
            }, ...others }),
        React.createElement("label", { htmlFor: id, className: hashClass(styled, clsx('radio-label')) }, children ? (children) : (React.createElement(React.Fragment, null,
            iconTile && React.createElement(Icon, { name: iconTile, size: IconSize.MEDIUM }),
            horizontalTile ? (React.createElement("span", null,
                tile ? React.createElement("span", { className: hashClass(styled, clsx('radio-title')) }, label) : label,
                tile && description && (React.createElement("span", { className: hashClass(styled, clsx('radio-description')) }, description)))) : (React.createElement(React.Fragment, null,
                tile ? React.createElement("span", { className: hashClass(styled, clsx('radio-title')) }, label) : label,
                tile && description && (React.createElement("span", { className: hashClass(styled, clsx('radio-description')) }, description)))))))));
};
export default Radio;
//# sourceMappingURL=Radio.js.map